module.exports = __webpack_public_path__ + "img/thinkphp.8a487344.svg";